import React from 'react';

export default function LotBasicInfo({ lot, services }) {
  return (
    <div className="border-t border-gray-200 px-6 py-6 sticky top-0 bg-white z-10">
      <div>
        <div className="flex items-baseline justify-between">
          <div className="flex items-baseline space-x-2">
            <h3 className="text-2xl font-bold text-gray-900">
              {lot.country}{' '}
              {lot.year}
              {lot.mint_mark && `-${lot.mint_mark}`}
              {lot.assayer && ` (${lot.assayer})`}{' '}
              {lot.denomination}
            </h3>
            {lot.variety && <span className="text-xl text-gray-600 ml-2">• {lot.variety}</span>}
            <div className="inline-flex items-baseline gap-2 ml-2 translate-y-[1px]">
              <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium
                ${lot.status === 'watching' ? 'bg-blue-100 text-blue-800' :
                  lot.status === 'won' ? 'bg-green-100 text-green-800' :
                  lot.status === 'lost' ? 'bg-red-100 text-red-800' :
                  lot.status === 'imported' ? 'bg-purple-100 text-purple-800' :
                  'bg-gray-100 text-gray-800'}`}>
                {lot.status.charAt(0).toUpperCase() + lot.status.slice(1)}
              </span>
            </div>
          </div>
        </div>
        
        <div className="mt-3 flex items-center">
          <div className="flex items-center">
            <div className="flex items-center space-x-2">
              <span className="text-xl font-bold text-gray-900">{lot.grade}</span>
              {lot.cac_sticker && lot.cac_sticker.toLowerCase() !== 'none' && (
                <span className={`px-2 py-0.5 text-sm font-semibold rounded-full ${
                  lot.cac_sticker.toLowerCase() === 'gold' 
                    ? 'bg-yellow-100 text-yellow-800 border border-yellow-200'
                    : 'bg-green-100 text-green-800 border border-green-200'
                }`}>
                  CAC
                </span>
              )}
            </div>
          </div>
          {lot.certification_number ? (
            <span className="text-lg text-gray-600 ml-2">
              {services[lot.certification_service_id]} Cert # {lot.certification_number}
            </span>
          ) : (
            <span className="text-lg text-gray-600 ml-2">
              Uncertified
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
